import { toast } from "@/hooks/use-toast";
import { useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import { buildBatchUploadToastContent } from "./BatchUploadProgressToastContent";
import type { BatchUploadProgress } from "./batchUploadTypes";

export function useBatchUploadProgressToast() {
  const { t } = useTranslation();
  const toastRef = useRef<ReturnType<typeof toast> | null>(null);

  const updateProgressToast = useCallback(
    (progress: BatchUploadProgress) => {
      const payload = {
        title: t("mediaLibrary.batch.uploadToastTitle"),
        description: buildBatchUploadToastContent(progress),
        duration: 600_000,
      };
      if (toastRef.current) {
        toastRef.current.update({ ...payload, id: toastRef.current.id });
      } else {
        toastRef.current = toast(payload);
      }
    },
    [t],
  );

  const dismissProgressToast = useCallback(() => {
    toastRef.current?.dismiss();
    toastRef.current = null;
  }, []);

  return { updateProgressToast, dismissProgressToast };
}
